import {createActions} from 'redux-actions';

export const {getLightApps, getLightAppsSuccess, getLightAppsFailure} = createActions({
    GET_LIGHT_APPS: () => {},
    GET_LIGHT_APPS_SUCCESS: (payload: any) => payload,
    GET_LIGHT_APPS_FAILURE: (error: any) => error,
});
